import { WidgetInstance } from "friendly-challenge";

document.addEventListener("alpine:init", () => {

    Alpine.data("patientIdentification", () => ({
        currentStep: 1,
        invoice: null,
        code: null,
        loading: false,
        formDataTemplate: {
            step1: {
                invoice: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
                code: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
                captcha: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
            },
            step2: {
                name: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
                zip: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
                city: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
                country: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
                iban: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
                code: {
                    value: "",
                    valid: true,
                    messageCode: "",
                },
            },
        },
        form: null,
        captcha: null,
        captchaInited: false,
        init() {
            console.log('patient identification init');

            const queryParams = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });

            this.form = JSON.parse(JSON.stringify(this.formDataTemplate));
            this.form.step1.invoice.value = queryParams.invoicenbr || "";
            this.form.step1.code.value = queryParams.acctoken || "";
            
            this.initCaptcha();
        },
        initCaptcha() {
            const options = {
                doneCallback: (token) => this.handleCaptcha(token),
                readyCallback: () => this.captchaReady(),
                sitekey: this.$refs.captcha.dataset.sitekey,
                language: this.$refs.captcha.dataset.lang,
                startMode: "focus",
            };
            this.captcha = new WidgetInstance(this.$refs.captcha, options);
        },
        handleCaptcha(token) {
            this.form.step1.captcha.value = token;
            console.log('captcha token', token);
        },
        captchaReady() {
            this.captchaInited = true;
            console.log('captcha ready');
        },
        mapStep(step) {
            return Object.fromEntries(
                Object.entries(step).map(
                    ([key, value], i) => [key, value.value]
                )
            );
        },
        submitStep(step, urlPart) {
            const url = '/patient-identification/' + urlPart;
            return fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams(this.mapStep(step)),
            });
        },
        step1SubmitDisabled() {
            return this.loading || !this.captchaInited || !this.form.step1.captcha.value;
        },
        async submitStep1() {
            console.log('patient identification submit step 1');

            if (this.loading || !this.captchaInited || !this.form.step1.captcha.value) {
                return;
            }

            if (!this.validateStep1()) {
                return;
            }

            this.loading = true;
            const response = await this.submitStep(this.form.step1, 'step1');
            this.loading = false;

            // window.response = response;

            const result = await response.json();
            if (response.status !== 200 || !result || !result.status || !result.data || !result.data.code) {

                if (result.validation) {
                    if (result.validation.code) {
                        this.form.step1.code.valid = false;
                        this.form.step1.code.messageCode = result.validation.code;
                    }

                    if (result.validation.invoice) {
                        this.form.step1.invoice.valid = false;
                        this.form.step1.invoice.messageCode = result.validation.invoice;
                    }
                }

                this.captcha.reset();
                this.form.step1.captcha.value = "";
                this.form.step1.captcha.valid = true;
                this.form.step1.captcha.messageCode = "";
                return;
            }

            if (result.data) {
                this.form.step2.name.value = result.data.name || "";
                this.form.step2.zip.value = result.data.zip || "";
                this.form.step2.city.value = result.data.city || "";
                this.form.step2.country.value = result.data.country || "";
                this.form.step2.code.value = result.data.code || "";
            }

            this.currentStep = 2;
        },
        validateStep1Invoice() {
            if (this.form.step1.invoice.value.trim() === "") {
                this.form.step1.invoice.valid = false;
                this.form.step1.invoice.messageCode = "required";
            } else {
                this.form.step1.invoice.valid = true;
                this.form.step1.invoice.messageCode = "";
            }
        },
        validateStep1Code() {
            if (this.form.step1.code.value.trim() === "") {
                this.form.step1.code.valid = false;
                this.form.step1.code.messageCode = "required";
            } else {
                this.form.step1.code.valid = true;
                this.form.step1.code.messageCode = "";
            }
        },
        validateStep1() {
            this.validateStep1Code();
            this.validateStep1Invoice();
            return this.checkIfStepValid(this.form.step1);
        },
        validateStep2Name() {
            if (this.form.step2.name.value.trim() === "") {
                this.form.step2.name.valid = false;
                this.form.step2.name.messageCode = "required";
            } else {
                this.form.step2.name.valid = true;
                this.form.step2.name.messageCode = "";
            }
        },
        validateStep2Zip() {
            if (this.form.step2.zip.value.trim() === "") {
                this.form.step2.zip.valid = false;
                this.form.step2.zip.messageCode = "required";
            } else {
                this.form.step2.zip.valid = true;
                this.form.step2.zip.messageCode = "";
            }
        },
        validateStep2City() {
            if (this.form.step2.city.value.trim() === "") {
                this.form.step2.city.valid = false;
                this.form.step2.city.messageCode = "required";
            } else {
                this.form.step2.city.valid = true;
                this.form.step2.city.messageCode = "";
            }
        },
        validateStep2Country() {
            if (this.form.step2.country.value.trim() === "") {
                this.form.step2.country.valid = false;
                this.form.step2.country.messageCode = "required";
            } else {
                this.form.step2.country.valid = true;
                this.form.step2.country.messageCode = "";
            }
        },
        validateStep2Iban() {
            if (this.form.step2.iban.value.trim() === "") {
                this.form.step2.iban.valid = false;
                this.form.step2.iban.messageCode = "required";
            } else {
                this.form.step2.iban.valid = true;
                this.form.step2.iban.messageCode = "";
            }
        },
        validateStep2() {
            this.validateStep2Name();
            this.validateStep2Zip();
            this.validateStep2City();
            this.validateStep2Country();
            this.validateStep2Iban();
            return this.checkIfStepValid(this.form.step2);
        },
        checkIfStepValid(step) {
            for (const [key, value] of Object.entries(step)) {
                if (!value.valid) return false;
            }
            return true;
        },
        async submitStep2() {

            console.log('patient identification submit step 2');

            if (this.loading) {
                return;
            }

            if (!this.validateStep2()) {
                return;
            }

            this.loading = true;
            const response = await this.submitStep(this.form.step2, 'step2');
            this.loading = false;

            // window.response = response;

            const result = await response.json();
            if (response.status !== 200 || !result || !result.status) {

                if (result.validation) {
                    if (result.validation.zip) {
                        this.form.step2.zip.valid = false;
                        this.form.step2.zip.messageCode = result.validation.zip;
                    }

                    if (result.validation.name) {
                        this.form.step2.name.valid = false;
                        this.form.step2.name.messageCode = result.validation.name;
                    }

                    if (result.validation.city) {
                        this.form.step2.city.valid = false;
                        this.form.step2.city.messageCode = result.validation.city;
                    }

                    if (result.validation.country) {
                        this.form.step2.country.valid = false;
                        this.form.step2.country.messageCode = result.validation.country;
                    }

                    if (result.validation.iban) {
                        this.form.step2.iban.valid = false;
                        this.form.step2.iban.messageCode = result.validation.iban;
                    }
                }

                return;
            }

            this.currentStep = 3;
        },
        resetForm() {
            console.log('patient identification reset steps');
            this.currentStep = 1;
            this.form = JSON.parse(JSON.stringify(this.formDataTemplate));
            this.captcha.reset();
        },
    }));
});